import countries from "i18n-iso-countries";
// Register Dutch locale
countries.registerLocale(require("i18n-iso-countries/langs/nl.json"));

export function getCountryNameFromAlpha3(alpha3Code) {
    if (!alpha3Code) return "";
    
    try {
        const dutchName = countries.getName(alpha3Code, "nl", { select: "alias" }) || 
                         countries.getName(alpha3Code, "nl", { select: "official" });
        
        return dutchName || alpha3Code;
    } catch (error) {
        console.error("Error translating country code:", error);
        return alpha3Code;
    }
} 
